import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Back () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.backTender.name}
            options={[
              {
                label: 'Non-Tender',
                value: 'Non-Tender'
              },
              {
                label: 'Tender',
                value: 'Tender'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.backMasses.name}
            options={[
              {
                label: 'No Masses',
                value: 'No Masses'
              },
              {
                label: 'Masses',
                value: 'Masses'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.backCVA.name}
            options={[
              {
                label: 'No CVA Tenderness',
                value: 'No CVA Tenderness'
              },
              {
                label: 'CVA Tenderness',
                value: 'CVA Tenderness'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.backROM.name}
            options={[
              {
                label: 'Full ROM',
                value: 'Full ROM'
              },
              {
                label: 'Limited ROM',
                value: 'Limited ROM'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.backAlignment.name}
            options={[
              {
                label: 'Proper Alignment',
                value: 'Proper Alignment'
              },
              {
                label: 'Abnormal Alignment',
                value: 'Abnormal Alignment'
              }
            ]}
          />
        </div>
        <div className='col-xs-offset-1 col-xs-11 margin-top'>
          <CheckboxInput {...PEQuestionnaire.backOther} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.backOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Back
